import { useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import echo from '../configs/echo';
import { useNavigate } from 'react-router-dom';

const Layout = ({ children, maxWidthClass = "max-w-7xl" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const channel = echo.channel('order');

    const notificationOptions = {
      body: "Bạn vừa nhận được một đơn hàng mới! Nhấn vào đây để xem chi tiết.",
      icon: "https://i.imgur.com/9BsDpgy.png",
      image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=400&q=80",
      badge: "https://i.imgur.com/9BsDpgy.png",
      requireInteraction: true,
    };

    const notificationTitle = "🍕 Đơn hàng mới từ Pizzata!";

    const handler = () => {
      const audio = new Audio('/new_order.mp3'); 
      audio.play();

      if (window.Notification && Notification.permission === "granted") {
        const notification = new Notification(notificationTitle, notificationOptions);
        notification.onclick = function(event) {
          event.preventDefault();
          window.focus();
          window.location.href = "/orders";
        };
      } else if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            const notification = new Notification(notificationTitle, notificationOptions);
            notification.onclick = function(event) {
              event.preventDefault();
              window.focus();
              window.location.href = "/orders";
            };
          }
        });
      }

      audio.onended = () => {
        window.focus();
        window.location.href = "/orders";
      };
    };

    channel.listen('.order', handler)
      .error((error) => {
        console.error('Lỗi kết nối:', error);
      });

    // Cleanup: hủy listener khi component unmount
    return () => {
      channel.stopListening('.order', handler);
    };
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1">
        <Navbar />
        <main className={`${maxWidthClass} mx-auto py-6 px-4 sm:px-6 lg:px-8`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout; 